import { Box, Button, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import lexoLogo from '@/assets/icons/lexo-sidenav-collapsed-logo.svg';

interface Props {
    mainText?: string;
    subText?: string;
    onRetry?: () => void;
    retryLabel?: string;
}

export default function LexoErrorCard({
    mainText = 'An error occurred',
    subText,
    onRetry = () => {
        window.location.reload();
    },
    retryLabel = 'Try again',
}: Props) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                width: '400px',
                maxWidth: '400px',
                padding: '24px',
                boxSizing: 'border-box',
                gap: '16px',
                borderRadius: '4px',
                backgroundColor: theme.palette.primary.P_600,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '130px',
                }}
            >
                <img width="50" src={lexoLogo} alt="" />
            </div>
            <Typography
                sx={{
                    marginBottom: '8px',
                    color: theme.palette.neutral.white,
                    textAlign: 'center',
                }}
                variant="h3"
            >
                {mainText}
            </Typography>
            <Typography
                sx={{
                    marginBottom: '8px',
                    color: theme.palette.neutral.white,
                    textAlign: 'center',
                }}
                variant="body2"
            >
                {subText ?? 'Please try again.'} If the issue persists, email{' '}
                <Link
                    href="mailto:support@lexo.ai"
                    sx={{
                        color: theme.palette.neutral.white,
                        textDecoration: 'underline',
                    }}
                >
                    Lexo Support
                </Link>
                .
            </Typography>
            <Button
                variant="contained"
                onClick={onRetry}
                sx={{
                    alignSelf: 'center',
                    backgroundColor: theme.palette.neutral.white,
                    color: theme.palette.primary.P_600,
                    '&:hover': {
                        backgroundColor: theme.palette.neutral.white,
                        opacity: 0.9,
                    },
                }}
            >
                {retryLabel}
            </Button>
        </Box>
    );
}
